import DashBoardSideBar from '../Dashboard/LeftSideMenu';
import React from 'react';


const UserListLeftSection = ({isMenuOpen, toggleMenu}) => {
  
  return <DashBoardSideBar isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
}
export default UserListLeftSection
